import { CheckCircle2, LoaderCircle, ShieldAlert } from "lucide-react";
import type { Conversation } from "@lumen/shared";
import { t } from "../../i18n";

export function ConversationStatusIndicator({
  conversation,
  selected,
}: {
  conversation: Conversation;
  selected: boolean;
}) {
  const actionRequired = conversation.attention === "action-required";
  const responseReady = conversation.attention === "response-ready";
  const generating = conversation.generationStatus === "running";
  const showAttention = actionRequired || (responseReady && !selected);

  if (!showAttention && !generating) return null;

  return (
    <>
      {showAttention && (
        <span
          role="img"
          aria-label={
            actionRequired ? t("Action required") : t("Response complete")
          }
          title={actionRequired ? t("Action required") : t("Response complete")}
          className={`mr-1 shrink-0 ${actionRequired ? "text-amber-600 dark:text-amber-300" : "text-lumen-600 dark:text-lumen-300"}`}
        >
          {actionRequired ? (
            <ShieldAlert size={15} />
          ) : (
            <CheckCircle2 size={15} />
          )}
        </span>
      )}
      {generating && (
        <span
          role="img"
          aria-label={t("Generating response")}
          title={t("Generating response")}
          className="mr-1 shrink-0 text-lumen-600 dark:text-lumen-300"
        >
          <LoaderCircle size={15} className="animate-spin" />
        </span>
      )}
    </>
  );
}
